<ng-template #content let-modal>
  <div class="modal-header"  style="border: none;     height: 45px;">
    <h4 style="font-size: 16px; font-weight: 500;" class="modal-title ml-0"></h4>
    <button type="button"  aria-label="Close" class="button-close" (click)="closeModal()" style="border: none;background: transparent;">
      <span aria-hidden="true" style="    font-size: 30px;">
        &times;
      </span> </button>
  </div>
  <div class="modal-body  text-center">
     <div class="col-12 justify-content-center align-content-center text-center">
        <h6> Are you sure you want to logout?</h6>
        <div class=" d-flex justify-content-center align-content-center text-center mt-4 mb-4">
          <button  (click)="logout()" class="me-2 mb-2 submit"> Logout</button>
          <button  (click)="closeModal()" class="cancle mb-2 me-2"> cancel  </button>
        </div>

     </div>
  </div>  
</ng-template>
<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)"> logout </button>

